/**
 * Myshield Portal — version constants
 *
 * HOW TO UPDATE ON A NEW RELEASE:
 *  1. Bump PORTAL_VERSION  (e.g. '1.7' → '1.8')
 *  2. Update PORTAL_VERSION_DATE to today's month + year
 *  3. Add a new entry to the TOP of the CHANGELOG array in
 *     src/components/security/ChangeLog.tsx, with current: true
 *     and set the previous entry's current to false.
 *  4. Build and deploy both frontend and backend.
 */

export const PORTAL_VERSION      = '2.1.03';
export const PORTAL_VERSION_DATE = 'November 2026';
export const PORTAL_VERSION_FULL = `v${PORTAL_VERSION} — ${PORTAL_VERSION_DATE}`;
